import { Platform, Text, View } from 'react-native';
import type { CSSProperties } from 'react';
import { Trans } from '@lingui/react/macro';

export const articleContentStyles: CSSProperties = {
    fontSize: 18,
    color: '#374151',
    lineHeight: 1.8,
};

export function injectArticleContentStyles(styleId: string) {
    if (Platform.OS !== 'web' || typeof document === 'undefined') return;
    if (document.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
        .news-article-content {
            font-family: Inter, Inter-fallback, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        }
        .news-article-content p {
            margin-bottom: 24px;
        }
        .news-article-content h2 {
            font-size: 26px;
            font-weight: 600;
            color: #2C5032;
            margin-top: 40px;
            margin-bottom: 20px;
        }
        .news-article-content h3 {
            font-size: 22px;
            font-weight: 600;
            color: #2C5032;
            margin-top: 32px;
            margin-bottom: 16px;
        }
        .news-article-content strong {
            font-weight: 600;
        }
        .news-article-content em {
            font-style: italic;
        }
        .news-article-content blockquote {
            border-left: 4px solid #5a8f32;
            padding-left: 20px;
            margin: 24px 0;
            font-style: italic;
            color: #6b7280;
        }
        .news-article-content blockquote p {
            margin-bottom: 0;
        }
        .news-article-content ul, .news-article-content ol {
            margin-bottom: 24px;
            padding-left: 24px;
        }
        .news-article-content li {
            margin-bottom: 12px;
        }
        .news-article-content a {
            color: #5a8f32;
            text-decoration: underline;
        }
        .news-article-content a:hover {
            color: #2C5032;
        }
    `;
    document.head.appendChild(style);
}

export function ArticleHtmlContent({ html, className }: { html: string; className?: string }) {
    if (Platform.OS !== 'web') {
        return (
            <View>
                <Text><Trans id="article.articlehtmlcontent.articleContentIsOptimizedForWebViewing" comment="UI copy in components/article/ArticleHtmlContent.tsx">Article content is optimized for web viewing.</Trans></Text>
            </View>
        );
    }

    return (
        <div
            className={className}
            style={articleContentStyles}
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
}
